import React from 'react';
import { Tabs, Toast } from 'antd-mobile';
import { Input, Divider, Popconfirm, Form, Table, Button } from 'antd';
import { onGet, onPost, api } from '../../core/api3';
import { getUrlParam } from '../../utils/commonUtils';
import 'antd-mobile/dist/antd-mobile.css';

class QuantRobotDetailMobileView extends React.Component {

    constructor() {
        super();
        this.state = {
            quantRobot: {}
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.getStatusData = this.getStatusData.bind(this);
        this.getStrategyData = this.getStrategyData.bind(this);
        this.getStrategyInteraction = this.getStrategyInteraction.bind(this);
    }

    componentDidMount() {
        document.title = '量化小子的老爸';
        this.loadData();
        this.dataPolling = setInterval(() => {
            this.loadData();
        }, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.dataPolling);
    }

    loadData() {
        let robotId = getUrlParam(this.props.location.search, 'robotId');
        onGet(api.getQuantRobot.url, api.getQuantRobot.params(robotId)).then(response => {
            if (response === undefined) {
                return;
            }
            let statusStr = ['未运行', '运行中', '停止中'];
            response.statusStr = statusStr[response.status];
            this.setState({ quantRobot: response });
        });
    }

    onClick(type, key) {
        switch (type) {
            case 'start':
                onPost(api.startRobot.url, api.startRobot.params(this.state.quantRobot.id)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    Toast.info('启动成功', 1);
                    this.loadData();
                });
                break;
            case 'stop':
                onPost(api.stopRobot.url, api.stopRobot.params(this.state.quantRobot.id)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    Toast.info('停止成功', 1);
                    this.loadData();
                });
                break;
            case 'update':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    onPost(api.updateQuantRobot.url, api.updateQuantRobot.params(this.state.quantRobot.id, JSON.stringify(fields))).then(response => {
                        if (response === undefined) {
                            return;
                        }
                        Toast.info('更新参数成功', 1);
                    });
                });
                break;
            case 'send':
                onPost(api.sendCommand.url, api.sendCommand.params(this.state.quantRobot.id, key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    Toast.info('发送交互指令成功', 1);
                    this.loadData();
                });
                break;
            case 'relogin':
                localStorage.removeItem('token');
                localStorage.removeItem('sessionId');
                window.location.reload();
                break;
            default:
                break;
        }
    }

    getStatusData() {
        if (this.state.quantRobot.statusData === undefined) {
            return;
        }
        let statusData = JSON.parse(this.state.quantRobot.statusData);
        let columns = statusData.cols.map((col, index) => {
            return {
                title: col,
                dataIndex: index + '',
                key: index + '',
                render: item => {
                    let dataSplitArray = item.split(' ');
                    if (dataSplitArray.length === 2) {
                        return <span style={{ color: dataSplitArray[1] }}>{dataSplitArray[0]}</span>
                    }
                    return <span>{dataSplitArray[0]}</span>
                }
            }
        });
        let dataSource = statusData.rows.map(row => {
            let rowData = {};
            row.forEach((data, index) => {
                rowData[index + ''] = data;
            });
            return rowData;
        });
        return (
            <Table scroll={{ x: 1200 }} dataSource={dataSource} columns={columns} pagination={false} />
        );
    }

    getStrategyData() {
        if (this.state.quantRobot.strategyData === undefined) {
            return;
        }
        let strategyData = JSON.parse(this.state.quantRobot.strategyData);
        return (
            <Form>
                {strategyData.map(data => {
                    return <Form.Item key={data.key} label={data.describe} style={{ marginBottom: 10 }} >
                        {this.props.form.getFieldDecorator(data.key, {
                            initialValue: data.value,
                            rules: [{ required: true, message: '请输入' + data.describe }]
                        })(
                            <Input placeholder={'请输入' + data.describe} maxLength="20" disabled={this.state.quantRobot.status !== 0} />
                        )}
                    </Form.Item>
                })}
            </Form>
        );
    }

    getStrategyInteraction() {
        if (this.state.quantRobot.strategyInteraction === undefined) {
            return;
        }
        let strategyInteraction = JSON.parse(this.state.quantRobot.strategyInteraction);
        return (
            <Form>
                {strategyInteraction.map(data => {
                    return <Form.Item key={data.key} label={data.describe} style={{ marginBottom: 20 }} >
                        <Popconfirm title={'确定要发送交互指令【' + data.value + '】？'} okText="确定" cancelText="取消" onConfirm={() => this.onClick('send', data.key)}>
                            <Button type="primary" disabled={this.state.quantRobot.status !== 1}>{data.value}</Button>
                        </Popconfirm>
                    </Form.Item>
                })}
            </Form>
        );
    }

    render() {
        const tabs = [
            { title: '基本信息' },
            { title: '状态信息' },
            { title: '策略参数' },
            { title: '策略交互' }
        ];
        return (
            <div style={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                <Tabs tabs={tabs} initialPage={0} swipeable={false}>
                    <div className="content2">
                        <Form>
                            <Form.Item style={{ marginBottom: 0 }}>
                                实盘名称：{this.state.quantRobot.name}
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                实盘策略：{this.state.quantRobot.strategyDescribe}
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                实盘状态：<span style={this.state.quantRobot.status !== 0 ? { color: '#FF0000' } : {}}>{this.state.quantRobot.statusStr}</span>
                                <Divider type="vertical" hidden={this.state.quantRobot.status === 2} />
                                <Popconfirm title="确定要启动实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('start')}>
                                    <a hidden={this.state.quantRobot.status !== 0}>启动</a>
                                </Popconfirm>
                                <Popconfirm title="确定要停止实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('stop')}>
                                    <a hidden={this.state.quantRobot.status !== 1}>停止</a>
                                </Popconfirm>
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                当前收益：{this.state.quantRobot.profit === undefined ? '0' : this.state.quantRobot.profit.toFixed(4)}
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                添加时间：{this.state.quantRobot.createTime}
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                最后运行时间：{this.state.quantRobot.lastRunTime === undefined ? '还未运行过' : this.state.quantRobot.lastRunTime}
                            </Form.Item>
                            {/* <Form.Item style={{ marginBottom: 0, marginTop: 20 }}>
                                <Button type="primary" onClick={() => this.onClick('relogin')}>重新登录</Button>
                            </Form.Item> */}
                        </Form>
                    </div>
                    <div className="content2">
                        {this.getStatusData()}
                    </div>
                    <div className="content2">
                        {this.getStrategyData()}
                        <Form.Item style={{ marginBottom: 0, marginTop: 20 }}>
                            <Popconfirm title="确定要更新参数？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('update')}>
                                <Button type="primary" disabled={this.state.quantRobot.status !== 0}>更新参数</Button>
                            </Popconfirm>
                        </Form.Item>
                    </div>
                    <div className="content2">
                        {this.getStrategyInteraction()}
                    </div>
                </Tabs>
            </div>
        );
    }

}

const QuantRobotDetailMobilePage = Form.create()(QuantRobotDetailMobileView);
export default QuantRobotDetailMobilePage;


// WEBPACK FOOTER //
// ./src/page/mobile/QuantRobotDetailMobilePage.jsx